import PropTypes from 'prop-types';
import React from 'react';

export default class AnnotationTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.state = {
            x: null,
            y: null,
        };
    }

    componentWillMount() {
        window.addEventListener('mousemove', this.handleMouseMove);
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleMouseMove);
    }

    handleMouseMove(e) {
        this.setState({ x: e.clientX, y: e.clientY });
    }

    render() {
        return (
            <div
                className="annotation-tooltip annotation-tooltip--active"
                style={{
                    left: this.state.x + 15 + 'px',
                    top: this.state.y - 14 + 'px',
                }}
            >
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/AnnotationTooltip.jsx